import { FunctionComponent } from "react";
import { useRouteError } from "react-router";

import { GlobalErrorFallback } from "./GlobalErrorFallback";

export const RouteErrorBoundary: FunctionComponent = () => {
  const error = useRouteError();
  const routeError = error instanceof Error ? error : null;

  return <GlobalErrorFallback error={routeError} />;
};
